<template>
  <div class="content">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>{{type==0?'添加角色':'编辑角色'}}
    </div>
    <div class="set_wrap">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="角色名称">
          <el-input type="text" placeholder="请输入角色名称" maxlength="60" show-word-limit
                    v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="角色描述">
          <el-input type="textarea" placeholder="请输入描述" maxlength="200" show-word-limit
                    v-model="form.desc"></el-input>
        </el-form-item>
        <el-form-item label="添加权限" class="mb-40">
          <p>企业后台权限</p>
          <!-- default-expanded-keys 默认展开的节点的 key 的数组 -->
          <!-- default-checked-keys 默认勾选的节点的 key 的数组 -->
          <el-tree
                  :data="dataline"
                  show-checkbox
                  node-key="id"
                  ref="tree"
                  :default-expanded-keys="expandedKeys"
                  :default-checked-keys="checkedKeys"
                  :props="defaultProps"
                  @node-click="nodeClick">
          </el-tree>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit(0)" size="small">保存</el-button>
          <el-button @click="onSubmit(1)" size="small">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "publishArticle",
    data() {
      return {
        form: {
          name: '',
          desc: '',
        },
        dataline: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        pageoption: this.$route.query,
        expandedKeys: [], // [2, 3] 默认展开
        checkedKeys: [1], // [5] 默认选中
        editInfo: '',
        type: ''
      };
    },
    created() {
      this.type = this.$route.query.type_;
      if (Number(this.pageoption.type_) === 1) {
        this.editInfo = JSON.parse(this.$route.query.option)
        this.form.name = this.editInfo.name
        this.form.desc = this.editInfo.desc
      }
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.role_tree, {role_id: this.editInfo.id || ''})
            .then(response => {
              if (response.data.code == 0) {
                let list_ = [];
                let tree_ = response.data.tree;
                let check_keys = []
                for (let i in tree_) {
                  // 第一层 如（商城）
                  let list_parents_one = {}
                  list_parents_one.id = tree_[i].id
                  list_parents_one.label = tree_[i].name
                  list_parents_one.children = []
                  if (Number(i) === 0) {
                    list_parents_one.disabled = true
                  }
                  // 第一级 id
                  if (tree_[i].is_chek) {
                    check_keys.push(tree_[i].id)
                  }
                  if (tree_[i].childs.length !== 0) {
                    let tree_two = []
                    for (let j in tree_[i].childs) {
                      // 第二层 如（商城-》商品管理）
                      let list_children_two = {}
                      list_children_two.id = tree_[i].childs[j].id
                      list_children_two.label = tree_[i].childs[j].name
                      list_children_two.children = []
                      // 第二级 id
                      if (tree_[i].childs[j].is_chek) {
                        check_keys.push(tree_[i].childs[j].id)
                      } else {
                        if (check_keys.indexOf(tree_[i].id) !== -1) {
                          check_keys.splice(check_keys.indexOf(tree_[i].id), 1)
                        }
                      }
                      if (tree_[i].childs[j].childs.length !== 0) {
                        let tree_three = []
                        for (let n in tree_[i].childs[j].childs) {
                          // 第三层 如（商城-》商品管理 -》商品列表）
                          let list_children = {}
                          list_children.id = tree_[i].childs[j].childs[n].id
                          list_children.label = tree_[i].childs[j].childs[n].name
                          tree_three.push(list_children)
                          // 第二级 id
                          if (tree_[i].childs[j].childs[n].is_chek) {
                            check_keys.push(tree_[i].childs[j].childs[n].id)
                          } else {
                            if (check_keys.indexOf(tree_[i].id) !== -1) {
                              check_keys.splice(check_keys.indexOf(tree_[i].id), 1)
                            }
                            if (check_keys.indexOf(tree_[i].childs[j].id) !== -1) {
                              check_keys.splice(check_keys.indexOf(tree_[i].childs[j].id), 1)
                            }
                          }
                        }
                        list_children_two.children = tree_three
                      }
                      tree_two.push(list_children_two)
                    }
                    list_parents_one.children = tree_two
                  }
                  list_.push(list_parents_one)
                }

                this.dataline = list_
                this.checkedKeys = check_keys
              }
            })
            .catch(response => {
            });
      },
      goback() {
        this.$router.go(-1);
      },
      onSubmit(type) {
        let data_ = {}
        data_.name = this.form.name
        data_.desc = this.form.desc
        data_.node = JSON.stringify(this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys()))
        if (!this.form.name) {
          this.$message.error('请填写角色名称');
          return
        }
        if (!this.form.desc) {
          this.$message.error('请填写角色描述');
          return
        }
        let url_ = api.role_add // role_edit
        let title = '添加角色成功' // type_ 0 添加 1 编辑
        if (Number(this.pageoption.type_) === 1) {
          title = '编辑角色成功'
          url_ = api.role_edit
          data_.role_id = this.editInfo.id
        }
        this.axios
            .post(url_, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: title,
                  center: true
                });
                this.$router.go(-1)
              } else {
              }
            })
            .catch(response => {
            });
      },
      nodeClick() {
      }
    },
    mounted() {
    },
  };
</script>

